"use client";

import { ReactNode } from "react";
import NextForm from "next/form";
import { GridRowId } from "@mui/x-data-grid-pro";
import { useAssignDialog } from "../Providers/AssignDialogContext";
import { useCampaignDialogs } from "../Providers/CampaignDialogsContext";
import { assignCampaignsAction } from "../actions";

interface FormProps {
  children: ReactNode;
}

export default function Form({ children }: FormProps) {
  const { setRowSelectionModel } = useCampaignDialogs();
  const { closeAssignDialog, campaignIdsToAssign } = useAssignDialog();

  const handleAction = async (formData: FormData) => {
    const result = await assignCampaignsAction(formData);
    if (result.success) {
      setRowSelectionModel({
        ids: new Set<GridRowId>([]),
        type: "include",
      });
      closeAssignDialog();
    } else {
      console.error("Error assigning campaigns:", result.error);
    }
  };

  return (
    <NextForm action={handleAction}>
      {campaignIdsToAssign.map((id) => (
        <input key={id} type="hidden" name="campaignIds" value={id} />
      ))}
      {children}
    </NextForm>
  );
}
